import * as z from 'zod';

// Login Schema and Type
export const loginSchema = z.object({
  email: z.email('Please enter a valid email address'),
  password: z.string().min(1, 'Password is required'),
});

export type LoginFormValues = z.infer<typeof loginSchema>;

// Reset Password Schema and Type
export const resetPasswordSchema = z.object({
  email: z.email('Please enter a valid email address'),
});

export type ResetPasswordFormValues = z.infer<typeof resetPasswordSchema>;

// MFA Steps Type
export type MfaStep =
  | 'CONFIRM_SIGN_IN_WITH_SMS_CODE'
  | 'CONFIRM_SIGN_IN_WITH_EMAIL_CODE'
  | 'CONFIRM_SIGN_IN_WITH_TOTP_CODE'
  | 'CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED';

export const newPasswordSchema = z
  .object({
    password: z
      .string()
      .min(12, 'Password must contain at least 12 characters')
      .regex(/\d/, 'Password must contain at least one number')
      .regex(
        /[!@#$%^&*(),.?":{}|<>]/,
        'Password must contain at least one special character',
      ),
    confirmPassword: z.string(),
  })
  .refine((data) => data.password === data.confirmPassword, {
    message: 'Passwords do not match',
    path: ['confirmPassword'],
  });

export type NewPasswordFormData = z.infer<typeof newPasswordSchema>;

// Reset Password Confirm Schema and Type
export const resetPasswordConfirmSchema = z
  .object({
    password: z
      .string()
      .min(12, 'Password must contain at least 12 characters')
      .regex(/\d/, 'Password must contain at least one number')
      .regex(
        /[!@#$%^&*(),.?":{}|<>]/,
        'Password must contain at least one special character',
      ),
    confirmPassword: z.string(),
    code: z
      .string()
      .regex(/^\d{6}$/, 'Confirmation code must be a 6-digit number'),
  })
  .refine((data) => data.password === data.confirmPassword, {
    message: 'Passwords do not match',
    path: ['confirmPassword'],
  });

export type ResetPasswordConfirmFormData = z.infer<
  typeof resetPasswordConfirmSchema
>;
